import { useDispatch, useSelector } from 'react-redux';
import { setStatus } from '../stores/repairRequest/slice';
import { AppDispatch, RootState } from '../stores/store';
import { API_CODE } from '../_constants/apiConst';
import { putStatus } from '../stores/status/slice';
import { isFulfilled } from '@reduxjs/toolkit';

const useUpdateStatus = () => {
  const dispatch: AppDispatch = useDispatch();
  const { repairRequest } = useSelector(
    (state: RootState) => state.repairRequest,
  );
  /** 修理依頼のステータス更新 */
  const updateStatus = async (
    newStatus: number,
    qcCount: number,
    showApiError: (
      apiError: unknown,
      apiCode: string,
      onCloseCallback?: () => void,
    ) => void,
  ) => {
    if (!repairRequest) {
      return false;
    }

    const response = await dispatch(
      putStatus({
        rmaNo: repairRequest.rmaNo,
        status: newStatus,
        qcCount,
      }),
    );
    // 成功時、storeの値も更新
    if (isFulfilled(response)) {
      dispatch(setStatus(newStatus));
      return true;
    }

    // 失敗時
    showApiError(response.payload, API_CODE.STATUS);
    return false;
  };

  return updateStatus;
};

export default useUpdateStatus;
